import React from "react";
import { Card } from "collections/Cards";
import {
  GrantProps,
  RoleProps,
  RolePropsi18n,
  TenantProps
} from "./ProfileView";
import { useTranslation } from "utilities/i18n";

export enum Permissions {
  UPDATE_DEVICE = "update:device"
}

function verifyTags(tags: string[]) {
  const validTags = [
    "user-assignable",
    "sp-user-assignable",
    "disti-user-assignable",
    "poly-admin-assignable"
  ];
  for (let i = 0; i < validTags.length; i++)
    if (tags.includes(validTags[i])) return true;
  return false;
}

export const findRoleForTenant = (
  id: string,
  grants: Array<GrantProps>
): RolePropsi18n => {
  let grant = grants.find((grant: GrantProps) => {
    return grant.resourceId === id;
  });

  let role: RoleProps = { name: "NONE" };
  if (grant && grant.roles) {
    let newRole = grant.roles.find(role => verifyTags(role.tags));
    role = newRole ?? { name: "NONE" }; // in case there is no user assignable role for the user
  }

  return role as RolePropsi18n;
};

export const PermissionsCard: React.FC<RolesProp> = props => {
  const { t } = useTranslation();

  return (
    <>
      <h6 className="section-title mb-1" data-testid="permissions-section">
        {t("PERMISSIONS")}
      </h6>
      <Card key="permissions" className="table-card permissions-card pb-2">
        <RolesList {...props} />
      </Card>
    </>
  );
};

type RolesProp = {
  tenants: Array<TenantProps>;
  loggedInUserGrants: Array<GrantProps>;
};
const RolesList: React.FC<RolesProp> = ({ tenants, loggedInUserGrants }) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        key="table-header"
        className="grid"
        data-testid="permission-table-header"
      >
        <div className="col-6 col-lg-4 tenant-name">
          <strong>{t("ACCOUNT")}</strong>
        </div>
        <div className="col-6 col-lg-4 mt-1">
          <strong>{t("ROLE")}</strong>
        </div>
      </div>
      {tenants.map((tenant: TenantProps) => {
        let roleInfo: string | React.ReactNode = t(
          findRoleForTenant(tenant.id, loggedInUserGrants).name
        );

        return (
          <div key={tenant.id} className="grid" data-testid="permission-line">
            <div className="col-6 col-lg-4 tenant-name">
              <strong>{tenant.name ? tenant.name : t("MY_ORG")}</strong>
            </div>
            <div className={`col-6 col-lg-4 mt-1`}>{roleInfo}</div>
          </div>
        );
      })}
    </>
  );
};

export default PermissionsCard;
